module.exports = __webpack_public_path__ + "static/media/29FUNOV8.7c28e4b6.jpg";